import script from "./XPageDataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./XPageDataTable.vue?vue&type=script&lang=ts&setup=true"

import "./XPageDataTable.vue?vue&type=style&index=0&id=37913f26&lang=scss&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37913f26"]])

export default __exports__